export default "__VITE_ASSET__BFcHh_8r__"